import { createContext } from "react";

import type { LocalePreference } from "./i18n";

/** 言語変更時は画面全体を再描画し、Polarisの文言も同時に切り替える。 */
export const LocaleChangeContext = createContext<
  (preference: LocalePreference) => boolean
>(() => false);
